export default __webpack_public_path__ + "static/media/home_banner_pic.4af042d6.png";